"use client";

import { useEffect } from "react";

// Trava o scroll do <body> via refcount compartilhado. Vários componentes
// podem pedir o lock ao mesmo tempo (modal dentro de outro modal, lightbox
// dentro do preview fullscreen, etc.). O overflow só volta ao valor
// original quando TODOS os locks soltarem — evita o bug em que um
// componente desmonta com lock ativo e "restaura" o body pra "hidden"
// (valor que o pai tinha travado).

let lockCount = 0;
let originalOverflow: string | null = null;

function acquire() {
  if (typeof document === "undefined") return;
  if (lockCount === 0) {
    originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  lockCount += 1;
}

function release() {
  if (typeof document === "undefined") return;
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = originalOverflow ?? "";
    originalOverflow = null;
  }
}

export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    acquire();
    return release;
  }, [active]);
}
